var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mouse_body"},[_c('div',{staticClass:"mouse"}),_c('p',{staticClass:"mouse_p"},[_vm._v("滚 动 鼠 标")])])}]

export { render, staticRenderFns }